import(/* webpackMode: "eager" */ "/root/services/fash-creative/src/app/global-error.jsx")